module.exports = __webpack_public_path__ + "img/eoy-giving-donate-1.b3d4cc95.jpg";